import { render, staticRenderFns } from "./AppEmpty.vue?vue&type=template&id=9574407a&scoped=true&"
import script from "./AppEmpty.vue?vue&type=script&lang=js&"
export * from "./AppEmpty.vue?vue&type=script&lang=js&"
import style0 from "./AppEmpty.vue?vue&type=style&index=0&id=9574407a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9574407a",
  null
  
)

export default component.exports